export function updategetCustomSignalSMA(state, customsignaldata) {
  state.getCustomSignalDataSMA = customsignaldata.reverse().map((item) => {
    return {
      id: item.id,
      name: item.name,
      high: item.high,
      low: item.low,
      time_period: item.time_period,
      updated_at: new Date(item.updated_at).toLocaleString(),
      sell_signals: item.sell_signals.join(", "),
      buy_signals: item.buy_signals.join(", "),
    };
  });
}
export function updateCustomSignalSMA(state, signaldata) {
  state.customSignalDataSMA = {
    id: signaldata.id,
    name: signaldata.name,
    high: signaldata.high,
    low: signaldata.low,
    time_period: signaldata.time_period,
    updated_at: new Date(signaldata.updated_at).toLocaleString(),
    sell_signals: signaldata.sell_signals.join(", "),
    buy_signals: signaldata.buy_signals.join(", "),
  };
  state.getCustomSignalDataSMA = [
    state.customSignalDataSMA,
    ...state.getCustomSignalDataSMA,
  ];
}

export function updategetCustomSignalRSI(state, customsignaldata) {
  state.getCustomSignalDataRSI = customsignaldata.reverse().map((item) => {
    return {
      id: item.id,
      name: item.name,
      high: item.high,
      low: item.low,
      time_period: item.time_period,
      updated_at: new Date(item.updated_at).toLocaleString(),
      sell_signals: item.sell_signals.join(", "),
      buy_signals: item.buy_signals.join(", "),
    };
  });
}
export function updateCustomSignalRSI(state, signaldata) {
  state.customSignalDataRSI = {
    id: signaldata.id,
    name: signaldata.name,
    high: signaldata.high,
    low: signaldata.low,
    time_period: signaldata.time_period,
    updated_at: new Date(signaldata.updated_at).toLocaleString(),
    sell_signals: signaldata.sell_signals.join(", "),
    buy_signals: signaldata.buy_signals.join(", "),
  };
  state.getCustomSignalDataRSI = [
    state.customSignalDataRSI,
    ...state.getCustomSignalDataRSI,
  ];
}

export function updategetCustomSignalMACD(state, customsignaldata) {
  state.getCustomSignalDataMACD = customsignaldata.reverse().map((item) => {
    return {
      id: item.id,
      name: item.name,
      low: 9,
      medium: 12,
      high: 26,
      time_period: item.time_period,
      updated_at: new Date(item.updated_at).toLocaleString(),
      sell_signals: item.sell_signals.join(", "),
      buy_signals: item.buy_signals.join(", "),
    };
  });
}
export function updateCustomSignalMACD(state, signaldata) {
  state.customSignalDataMACD = {
    id: signaldata.id,
    name: signaldata.name,
    low: 9,
    medium: 12,
    high: 26,
    time_period: signaldata.time_period,
    updated_at: new Date(signaldata.updated_at).toLocaleString(),
    sell_signals: signaldata.sell_signals.join(", "),
    buy_signals: signaldata.buy_signals.join(", "),
  };
  state.getCustomSignalDataMACD = [
    state.customSignalDataMACD,
    ...state.getCustomSignalDataMACD,
  ];
}

export function updategetCustomSignalEMA(state, customsignaldata) {
  state.getCustomSignalDataEMA = customsignaldata.reverse().map((item) => {
    return {
      id: item.id,
      name: item.name,
      high: item.high,
      low: item.low,
      time_period: item.time_period,
      updated_at: new Date(item.updated_at).toLocaleString(),
      sell_signals: item.sell_signals.join(", "),
      buy_signals: item.buy_signals.join(", "),
    };
  });
}
export function updateCustomSignalEMA(state, signaldata) {
  state.customSignalDataEMA = {
    id: signaldata.id,
    name: signaldata.name,
    high: signaldata.high,
    low: signaldata.low,
    time_period: signaldata.time_period,
    updated_at: new Date(signaldata.updated_at).toLocaleString(),
    sell_signals: signaldata.sell_signals.join(", "),
    buy_signals: signaldata.buy_signals.join(", "),
  };
  state.getCustomSignalDataEMA = [
    state.customSignalDataEMA,
    ...state.getCustomSignalDataEMA,
  ];
}

export function updategetCustomSignalSuperTrend(state, customsignaldata) {
  state.getCustomSignalDataSuperTrend = customsignaldata
    .reverse()
    .map((item) => {
      return {
        id: item.id,
        name: item.name,
        length: item.length,
        multiplier: item.multiplier,
        time_period: item.time_period,
        updated_at: new Date(item.updated_at).toLocaleString(),
        sell_signals: item.sell_signals.join(", "),
        buy_signals: item.buy_signals.join(", "),
      };
    });
}
export function updateCustomSignalSuperTrend(state, signaldata) {
  state.customSignalDataSuperTrend = {
    id: signaldata.id,
    name: signaldata.name,
    length: signaldata.length,
    multiplier: signaldata.multiplier,
    time_period: signaldata.time_period,
    updated_at: new Date(signaldata.updated_at).toLocaleString(),
    sell_signals: signaldata.sell_signals.join(", "),
    buy_signals: signaldata.buy_signals.join(", "),
  };
  state.getCustomSignalDataSUperTrend = [
    state.customSignalDataSuperTrend,
    ...state.getCustomSignalDataSuperTrend,
  ];
}
export function updategetCustomSignalDI(state, customsignaldata) {
  state.getCustomSignalDataDI = customsignaldata.reverse().map((item) => {
    return {
      id: item.id,
      name: item.name,
      positive: item.positive,
      negative: item.negative,
      time_period: item.time_period,
      updated_at: new Date(item.updated_at).toLocaleString(),
      sell_signals: item.sell_signals.join(", "),
      buy_signals: item.buy_signals.join(", "),
    };
  });
}
export function updateCustomSignalDI(state, signaldata) {
  state.customSignalDataDI = {
    id: signaldata.id,
    name: signaldata.name,
    positive: signaldata.positive,
    negative: signaldata.negative,
    time_period: signaldata.time_period,
    updated_at: new Date(signaldata.updated_at).toLocaleString(),
    sell_signals: signaldata.sell_signals.join(", "),
    buy_signals: signaldata.buy_signals.join(", "),
  };
  state.getCustomSignalDataDI = [
    state.customSignalDataDI,
    ...state.getCustomSignalDataDI,
  ];
}
export function updategetCustomSignalPSAR(state, customsignaldata) {
  state.getCustomSignalDataPSAR = customsignaldata.reverse().map((item) => {
    return {
      id: item.id,
      name: item.name,
      start: item.start,
      increment: item.increment,
      maximum: item.maximum,
      time_period: item.time_period,
      updated_at: new Date(item.updated_at).toLocaleString(),
      sell_signals: item.sell_signals.join(", "),
      buy_signals: item.buy_signals.join(", "),
    };
  });
}
export function updateCustomSignalPSAR(state, signaldata) {
  state.customSignalDataPSAR = {
    id: signaldata.id,
    name: signaldata.name,
    start: signaldata.start,
    increment: signaldata.increment,
    maximum: signaldata.maximum,
    time_period: signaldata.time_period,
    updated_at: new Date(signaldata.updated_at).toLocaleString(),
    sell_signals: signaldata.sell_signals.join(", "),
    buy_signals: signaldata.buy_signals.join(", "),
  };
  state.getCustomSignalDataPSAR = [
    state.customSignalDataPSAR,
    ...state.getCustomSignalDataPSAR,
  ];
}

export function updateSaveModelSubmitedCount(state, count){
  state.saveModelSubmited += 1 
}